import { PublicShell } from "../../components/Layouts";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Layers, Share2, TrendingUp } from "lucide-react";

export default function ReferralProgram() {
  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">4-LEVEL UNILEVEL NETWORK</div>
          <h1>Build a network that<br /><em>compounds.</em></h1>
          <p>Share your referral link and earn commissions on four levels of participation. Rates are published by the administrator and can be adjusted over time without changing the historical records.</p>
        </div>
        <div className="feature-grid">
          <article className="feature"><div className="feature-icon"><Share2 /></div><h3>Your referral link</h3><p>Every member gets a unique referral code and a shareable registration link.</p></article>
          <article className="feature"><div className="feature-icon"><Users /></div><h3>Direct & indirect</h3><p>Level 1 is anyone who registers with your code. Levels 2, 3 and 4 are their networks.</p></article>
          <article className="feature"><div className="feature-icon"><Layers /></div><h3>Four levels</h3><p>Commissions roll up through four levels of your unilevel network.</p></article>
          <article className="feature"><div className="feature-icon"><TrendingUp /></div><h3>Fair rates</h3><p>Historical commissions never change. Only new activations use updated rates.</p></article>
        </div>
        <div style={{ marginTop: 40, display: "flex", gap: 12 }}>
          <Link to="/register" className="btn btn-accent" data-testid="referral-register-cta">Create account <ArrowRight size={15} /></Link>
          <Link to="/faq" className="btn btn-ghost" data-testid="referral-faq-cta">Read FAQ</Link>
        </div>
      </main>
    </PublicShell>
  );
}
